var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.$store.getters.isTrackingTimer && this.$store.getters.isInControl)?_c('span',{staticClass:"countdown-timer"},[_vm._v(" ("+_vm._s(this.$store.getters.remainingTime)+") ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }